import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { Avatar, Box, IconButton, Paper, Stack, Tooltip, Typography } from '@material-ui/core';
import moment from 'moment';
import { isToday } from 'date-fns';
import {
  experimentalStyled as styled
} from '@material-ui/core/styles'
import infoOutline from '@iconify/icons-ic/outline-info';
import Icon from '@iconify/react';

const MessageImgStyle = styled('img')(({ theme }) => ({
  height: 200,
  maxWidth: 296,
  width: '100%',
  cursor: 'pointer',
  objectFit: 'cover',
  borderRadius: theme.shape.borderRadius,
}));

JobNoteMessageItem.propTypes = {
  message: PropTypes.object.isRequired,
  allMembers: PropTypes.array
};

export default function JobNoteMessageItem({ message,allMembers }) {
  const theme = useTheme();
  const messageDate = moment.unix(message?.timestamp);
  const isTodayMessage = isToday(messageDate.toDate());
  const formattedDate = isTodayMessage
    ? messageDate.format('DD/MM/YYYY hh:mm A')
    : messageDate.format('DD/MM/YYYY hh:mm A');

    // Parse partner_id as array of strings
    const partnerIds = message?.partner_id
    ? message?.partner_id.split(',').map(id => id.trim())
    : [];
    // Get matching user names
    const partnerNames = allMembers
    ?.filter(user => partnerIds.includes(String(user.user_id)))
    .map(user => user.name)
    .join(', ') || 'No recipients';
    console.log('partnerNamespartnerNames', partnerNames)

  return (
    <Box
      justifyContent={message.direction === 'left' ? 'flex-start' : 'flex-end'}
      sx={{
        display: 'flex',
        ml: 'auto',
        alignItems: 'center',
        marginBottom: 3
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        {/* {message.direction === 'left' && (
        <Avatar
            sx={{ width: 38, height: 38 }}
            alt={message.name}
            src={message.profile_pic}
        />
        )} */}
        <Paper
          sx={{
            p: 1.5,
            flexGrow: 1,
            maxWidth: 400,
            bgcolor:
              message.direction === 'left'
                ? 'background.neutral'
                : theme.palette.primary.dark,
            color: message.direction === 'left' ? 'text.primary' : 'common.white',
            borderRadius: '12px'
          }}
        >
          {/* Image Display */}
          {message.image && (
            <MessageImgStyle
              alt="attachment"
              src={message.image}
            />
          )}

          {/* User Name and Message */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ sm: 'center' }}
            justifyContent="space-between"
            spacing={1}
            sx={{ my: 0.5 }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              {/* {message.image === '' && ( */}
                <Avatar
                  sx={{ width: 38, height: 38 }}
                  alt={message.name}
                  src={message.profile_pic}
                />
              {/* )} */}
              <Typography variant="subtitle2">
                {message.name}
              </Typography>
            </Stack>
            {/* Info Tooltip */}
            {/* <Tooltip title={partnerNames} arrow>
                <IconButton
                    size="small"
                    sx={{
                    p: 0.5,
                    color: theme.palette.text.secondary,
                    }}
                >
                    <Icon icon={infoOutline} width={20} height={20} />
                </IconButton>
            </Tooltip> */}

          </Stack>

          {/* Message Text */}
          <Box width={296}>
            <Typography
              variant="body2"
              sx={{
                // color:
                //   message.direction === 'left'
                //     ? 'text.secondary'
                //     : 'text.secondary',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal'
              }}
            >
              {message.message}
            </Typography>
          </Box>

          {/* Timestamp */}
          <Typography
            variant="caption"
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              mt: 0.5,
              color:
                message.direction === 'left'
                  ? 'text.disabled'
                  : 'common.white'
            }}
          >
            {formattedDate}
          </Typography>
        </Paper>
      </Stack>
    </Box>
  );
}
